// extracted by mini-css-extract-plugin
export default {"mailboxSelector":"InviteButton_mailboxSelector__4HvFz","mobile":"InviteButton_mobile__3Nuhe"};